// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Tpyi","left":"StickyBox_left__Fd4dt","right":"StickyBox_right__1IKyK"};